import React from 'react'

const CreateCampaignIcon = () => (
  <svg
    width="170"
    height="164"
    viewBox="0 0 170 164"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_17992_12861)">
      <path
        d="M46.4868 46.4993C46.4868 46.4993 64.5739 17.9257 100.729 29.1079C136.826 40.292 128.296 82.7479 128.273 82.8593C128.431 82.0815 134.684 81.3403 135.346 81.249C153.793 78.6621 167.514 94.9416 168.875 110.986C170.564 130.885 154.342 144.979 135.866 151.048"
        stroke="#E2E2FC"
        strokeWidth="1.4"
        strokeMiterlimit="10"
      />
      <path
        d="M130.203 159.978C129.681 161.793 129.301 162.83 129.301 162.83H129.029C129.46 161.905 129.851 160.954 130.203 159.978Z"
        fill="#2E3860"
      />
      <path
        d="M82.043 88.3474C82.043 88.3474 81.4207 92.0753 80.7763 95.4507C78.9351 95.4707 77.0939 95.4852 75.2729 95.4997C74.3523 90.3876 75.3521 86.3836 76.5397 83.7148C78.0366 87.083 80.2976 88.1076 82.043 88.3474Z"
        fill="#004360"
      />
      <path
        d="M112.306 101.798C108.562 99.8095 104.572 98.3103 100.436 97.3385L99.0806 97.1078C99.0806 97.1078 98.0716 94.8442 98.0661 94.8369C97.5929 93.6506 96.8085 92.0755 96.5655 90.8256C96.2694 89.3492 96.1974 87.8375 96.3519 86.3402C96.617 84.1166 97.6665 79.4132 99.563 77.9307C101.145 76.7027 101.796 76.9606 102.693 75.0404C103.337 73.6706 103.599 71.3688 102.347 70.3588C100.959 69.2506 100.366 69.8137 98.705 69.9845C92.3933 70.6022 88.7864 66.1204 86.4665 60.941C86.0983 60.0999 85.7153 59.2115 85.1132 58.4957C84.4228 57.671 83.4672 57.4857 82.6847 56.8189C82.3514 56.5319 82.1231 56.0632 82.2833 55.6563C82.3777 55.4618 82.5149 55.2905 82.6847 55.1548C84.1635 53.8107 85.9393 52.8248 87.8714 52.2754C90.9273 51.4035 94.1564 51.3042 97.2615 51.9865C100.502 53.0457 103.415 55.0513 105.376 58.1161C108.08 62.3508 108.732 66.7435 107.217 71.1218C105.665 75.6054 103.932 80.872 106.849 85.1866C110.732 90.9183 113.072 94.9495 112.306 101.798Z"
        fill="#004360"
      />
      <path
        d="M80.7842 95.4521C78.943 95.4721 77.1018 95.4867 75.2808 95.5012C61.4056 95.5721 48.125 95.3813 34.2056 97.8447"
        stroke="#2E3860"
        strokeWidth="1.4"
        strokeMiterlimit="10"
      />
      <path
        d="M98.8608 96.9756C99.3893 97.09 99.9122 97.2099 100.435 97.3389C102.473 97.825 104.48 98.4317 106.445 99.1556C108.46 99.8956 110.419 100.778 112.305 101.797C112.307 101.795 112.31 101.794 112.313 101.794C112.315 101.794 112.318 101.795 112.32 101.797C115.288 103.384 118.031 105.349 120.478 107.643C122.525 109.611 124.294 111.84 125.739 114.272C125.751 114.282 125.761 114.294 125.766 114.309C126.938 116.25 127.956 118.278 128.81 120.375C131.358 126.568 132.803 133.698 133.024 140.794C133.225 147.496 132.33 154.169 130.213 159.979C129.86 160.955 129.469 161.905 129.038 162.831C129.01 162.902 128.974 162.965 128.946 163.036"
        stroke="#2E3860"
        strokeWidth="1.4"
        strokeMiterlimit="10"
      />
      <path
        d="M106.86 162.943C106.86 162.943 106.86 162.929 106.86 162.921C106.872 162.892 106.881 162.862 106.887 162.831"
        stroke="#2E3860"
        strokeWidth="1.4"
        strokeMiterlimit="10"
      />
      <path
        d="M55.1484 37.6864C55.0624 36.8723 54.5261 36.1476 53.7297 35.6157L45.8277 30.3383C43.7889 28.9766 41.0049 29.5875 39.7163 31.6791L37.2534 35.677C35.8108 38.0188 36.9162 41.0688 39.5254 41.9459L48.9874 45.1265C49.8759 45.4251 50.7603 45.4177 51.4558 45.0164C52.4602 44.437 53.7288 43.4496 54.4789 41.9141C55.2217 40.3936 55.268 38.8196 55.1484 37.6864Z"
        fill="#2E3860"
        stroke="#2E3860"
        strokeWidth="1.4"
      />
      <path
        d="M52.9024 35.3924C52.8903 35.3098 52.8783 35.2373 52.8673 35.1758L40.1268 26.546L32.0848 39.7096L47.9491 44.9013C48.0116 44.8686 48.0853 44.8289 48.1686 44.7819C48.4638 44.6155 48.8769 44.36 49.3374 44.0092C50.2617 43.3051 51.3537 42.2345 52.081 40.751C52.8116 39.2609 52.996 37.7986 52.9951 36.7017C52.9947 36.1545 52.9481 35.7033 52.9024 35.3924Z"
        fill="#F9F9FF"
        stroke="#2E3860"
        strokeWidth="1.4"
      />
      <path
        d="M48.5692 32.3087C48.5604 32.2148 48.5512 32.1327 48.5426 32.0634L35.9055 23.2287L26.9067 38.1972L42.9285 43.1222C42.9971 43.0818 43.0788 43.0323 43.1718 42.9736C43.4863 42.775 43.9275 42.472 44.4228 42.061C45.4161 41.2369 46.6091 39.993 47.444 38.3017C48.2817 36.6047 48.5462 34.9689 48.6 33.7546C48.6268 33.1483 48.601 32.6508 48.5692 32.3087ZM48.5034 31.8009L48.5034 31.8007L48.5034 31.8009Z"
        fill="#004360"
        stroke="#2E3860"
        strokeWidth="1.4"
      />
      <path
        d="M37.0446 22.8139L29.1674 7.54688L11.6922 41.412L29.1674 38.6361C29.1674 38.6361 33.1083 36.4155 35.6379 31.6966C38.1676 26.9777 37.0446 22.8139 37.0446 22.8139Z"
        fill="white"
        stroke="#2E3860"
        strokeWidth="1.4"
      />
      <path
        d="M10.0164 19.2586C7.45808 24.4252 6.10487 29.5293 5.96114 33.5874C5.81486 37.7174 6.91572 40.4662 8.87882 41.4125C10.8419 42.3589 13.7161 41.5264 16.9281 38.8742C20.0842 36.2683 23.3332 32.0781 25.8914 26.9115C28.4497 21.745 29.803 16.6408 29.9467 12.5827C30.093 8.45273 28.9921 5.70397 27.029 4.75762C25.0659 3.81126 22.1917 4.64377 18.9797 7.29588C15.8237 9.90182 12.5747 14.092 10.0164 19.2586Z"
        fill="#E2E2FC"
        stroke="#2E3860"
        strokeWidth="1.4"
      />
      <path
        d="M12.2869 20.2261C8.42846 28.0183 7.788 35.5343 10.8564 37.0135C13.9248 38.4926 19.54 33.3749 23.3985 25.5827C27.2569 17.7905 27.8974 10.2745 24.829 8.79534C22.6206 7.73076 19.093 10.0833 15.8506 14.3907"
        stroke="#2E3860"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M25.2476 21.1185L20.1837 19.6904L16.2451 27.7804L20.465 30.8339C20.465 30.8339 22.0727 28.331 22.9969 26.63C24.1307 24.5434 25.2476 21.1185 25.2476 21.1185Z"
        fill="#2E3860"
      />
      <path
        d="M17.0642 23.2823C16.5976 24.3458 16.3899 25.3634 16.4057 26.1322C16.4228 26.9664 16.6796 27.236 16.8028 27.2886C16.9259 27.3412 17.3009 27.3414 17.929 26.7828C18.5079 26.268 19.1177 25.4222 19.5843 24.3586C20.0509 23.2951 20.2586 22.2775 20.2428 21.5087C20.2257 20.6745 19.9689 20.4049 19.8458 20.3523C19.7226 20.2997 19.3476 20.2995 18.7195 20.8581C18.1406 21.3729 17.5308 22.2187 17.0642 23.2823Z"
        fill="white"
        stroke="#2E3860"
        strokeWidth="1.4"
      />
      <path
        d="M102.001 122.091C102.001 122.091 106.008 124.011 108.641 130.006C109.965 133.02 110.946 137.073 110.889 142.432C110.889 142.432 110.889 142.432 110.889 142.447C110.859 145.864 110.403 149.81 109.342 154.357V154.383"
        stroke="#2E3860"
        strokeWidth="1.4"
        strokeMiterlimit="10"
      />
      <path
        d="M26.1802 45.9833C26.8872 43.3436 28.0214 40.6222 28.8738 39.4777C30.2142 37.6973 31.9634 36.0005 34.2133 36.1531C35.6587 36.2458 37.0782 37.0342 37.1427 38.5966C37.2034 40.2916 35.3917 42.1736 34.8099 43.7669C34.2575 45.3038 34.0053 47.0933 34.2962 48.7101C34.5871 50.327 36.0582 51.5896 37.6453 51.9366C38.2473 52.0929 38.8876 52.0073 39.4257 51.6986C40.9797 50.7285 35.7986 48.3269 35.736 46.8027C35.6623 45.0932 35.6642 43.1602 37.1427 41.9903C38.229 41.131 39.8768 41.7014 40.6778 42.6461C42.0697 44.2811 46.9742 45.9833 47.063 48.5739C47.2711 54.638 46.1793 60.4514 42.6 65.5563C40.7588 68.1923 38.8623 70.5577 38.1167 73.7914C35.7968 83.8414 35.539 90.8084 34.206 101.015"
        fill="white"
      />
      <path
        d="M26.1802 45.9833C26.8872 43.3436 28.0214 40.6222 28.8738 39.4777C30.2142 37.6973 31.9634 36.0005 34.2133 36.1531C35.6587 36.2458 37.0782 37.0342 37.1427 38.5966C37.2034 40.2916 35.3917 42.1736 34.8099 43.7669C34.2575 45.3038 34.0053 47.0933 34.2962 48.7101C34.5871 50.327 36.0582 51.5896 37.6453 51.9366C38.2473 52.0929 38.8876 52.0073 39.4257 51.6986C40.9797 50.7285 35.7986 48.3269 35.736 46.8027C35.6623 45.0932 35.6642 43.1602 37.1427 41.9903C38.229 41.131 39.8768 41.7014 40.6778 42.6461C42.0697 44.2811 46.9742 45.9833 47.063 48.5739C47.2711 54.638 46.1793 60.4514 42.6 65.5563C40.7588 68.1923 38.8623 70.5577 38.1167 73.7914C35.7968 83.8414 35.539 90.8084 34.206 101.015"
        stroke="#2E3860"
        strokeWidth="1.4"
        strokeMiterlimit="10"
      />
      <path
        d="M31.0129 46.9743C31.0968 47.0395 31.1879 47.11 31.2852 47.1849C31.8237 47.5991 32.5497 48.1442 33.3052 48.6723C34.0649 49.2035 34.8361 49.7045 35.4689 50.0393C35.7878 50.208 36.0458 50.3205 36.2348 50.3776C36.2572 50.3844 36.2775 50.39 36.2956 50.3946C36.6665 50.0082 36.8604 49.7342 36.9496 49.5472C36.9982 49.4455 37.0041 49.3932 37.0047 49.379C37.0047 49.3784 37.0048 49.3778 37.0048 49.3772C36.9781 49.3293 36.8897 49.2322 36.63 48.9955C36.6144 48.9813 36.5984 48.9668 36.5821 48.9519C36.3609 48.7508 36.0724 48.4885 35.804 48.1677C35.2007 47.4465 34.6966 46.4284 34.8858 44.9346C35.0269 43.8207 35.387 42.9714 35.8844 42.3364C36.2278 41.8981 36.623 41.5792 37.0247 41.3488L36.7917 41.2721L31.0129 46.9743ZM36.4151 50.4154C36.4151 50.4154 36.4139 50.4154 36.4117 50.4155C36.4141 50.4155 36.4152 50.4155 36.4151 50.4154Z"
        fill="#2E3860"
        stroke="#2E3860"
        strokeWidth="1.4"
      />
      <path
        d="M62.3098 163.103C55.1954 143.152 58.5648 121.356 58.5648 121.356L20.3489 122.551C18.7218 122.602 17.1026 122.308 15.6003 121.689C14.0981 121.07 12.7477 120.141 11.6401 118.964C10.5325 117.787 9.69354 116.389 9.17965 114.865C8.66575 113.341 8.48891 111.726 8.66101 110.129L18.0217 76.447L20.047 69.262C20.6928 67.0012 20.5449 64.5913 19.6272 62.424L18.6734 60.1785C18.6734 60.1785 16.9446 56.6996 20.8203 57.0266C22.9045 57.2082 24.9722 58.0821 26.7213 59.1794C28.0949 60.0423 30.1901 61.7118 29.542 63.563C28.7761 65.7431 25.7731 66.2881 24.0092 65.0618"
        stroke="#2E3860"
        strokeWidth="1.4"
        strokeMiterlimit="10"
      />
      <path
        d="M19.5317 57.0068C19.5317 57.0068 16.258 49.74 25.2394 51.6203C34.2207 53.5006 36.3713 63.1836 29.5165 62.0936"
        stroke="#2E3860"
        strokeWidth="1.4"
        strokeMiterlimit="10"
      />
      <path
        d="M22.4919 51.2055C22.4919 51.2055 19.6196 47.7629 23.9133 46.1188C28.207 44.4747 43.7982 52.2392 33.7969 59.8875"
        stroke="#2E3860"
        strokeWidth="1.4"
        strokeMiterlimit="10"
      />
      <path
        d="M84.6205 88.1829C83.7869 88.4086 82.9155 88.4643 82.0594 88.3465C80.3065 88.1066 78.0456 87.0748 76.556 83.7139C76.2466 83.027 75.9954 82.3161 75.8048 81.5883C75.0462 78.807 74.7148 74.9374 75.1586 69.5418C75.2451 68.5045 75.374 67.4508 75.5526 66.399C75.8482 64.5691 76.3249 62.7723 76.9758 61.0343C76.9758 61.0343 76.9758 61.0197 76.9906 61.0125C78.6145 56.7759 81.4702 53.2007 86.272 51.8254C89.8731 50.8005 93.7017 50.8549 97.2713 51.9817C100.512 53.0408 103.425 55.0464 105.386 58.1112C108.09 62.3459 108.742 66.7387 107.227 71.1169C105.675 75.6005 103.942 80.8671 106.858 85.1818C110.736 90.9225 113.076 94.9538 112.325 101.803"
        stroke="#2E3860"
        strokeWidth="1.4"
        strokeMiterlimit="10"
      />
      <path
        d="M73.8076 95.7128C72.3972 89.0401 74.301 84.175 75.7961 81.5898"
        stroke="#2E3860"
        strokeWidth="1.4"
        strokeMiterlimit="10"
      />
      <path
        d="M75.5522 66.3926C75.5522 66.3926 78.6399 63.2079 82.2174 68.2384"
        stroke="#2E3860"
        strokeWidth="1.4"
        strokeMiterlimit="10"
      />
      <path
        d="M81.6658 84.0126C82.928 84.7688 84.6371 84.2993 85.5664 83.1346C86.5758 81.871 86.9799 80.1841 87.1989 78.6537C87.2131 78.5433 87.2291 78.4346 87.2398 78.3242C85.6999 80.563 82.7108 81.1001 80.0796 81.334C80.1793 82.0661 80.4735 82.764 80.9359 83.3652C81.1338 83.6209 81.3813 83.8405 81.6658 84.0126Z"
        stroke="#2E3860"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M97.5962 93.5459L97.5864 93.5361"
        stroke="#2E3860"
        strokeWidth="1.4"
        strokeMiterlimit="10"
      />
      <path
        d="M85.4478 65.4151C85.4478 65.4151 86.4972 63.7383 90.0839 64.9736C93.6705 66.209 93.7129 68.2273 93.7129 68.2273"
        stroke="#2E3860"
        strokeWidth="1.4"
        strokeMiterlimit="10"
      />
      <path
        d="M77.2944 69.5842C77.2944 69.5842 78.9515 68.7576 80.2496 69.5842"
        stroke="#2E3860"
        strokeWidth="1.4"
        strokeMiterlimit="10"
      />
      <path
        d="M86.2246 70.3449C86.2246 70.3449 87.8817 69.5183 89.1705 70.3449"
        stroke="#2E3860"
        strokeWidth="1.4"
        strokeMiterlimit="10"
      />
      <path
        d="M82.0434 88.348C82.0434 88.348 81.4211 92.0759 80.7766 95.4513C80.6827 95.9309 80.5925 96.4033 80.5115 96.8701C80.0899 99.1428 79.7529 101.163 79.7382 101.775C79.6314 106.862 84.5051 109.796 89.213 109.747C95.8192 109.676 99.6821 103.612 99.0597 97.5387C98.6528 96.4305 98.2367 95.3223 97.8298 94.2141C97.3069 92.7935 96.6275 91.411 96.3329 89.914C96.0728 88.4393 96.0442 86.9338 96.2482 85.4504C96.5134 83.234 96.9497 79.9295 98.8462 78.4471C100.428 77.219 102.079 76.4124 102.981 74.4921C103.626 73.1223 103.596 71.3583 102.344 70.3482C100.956 69.2401 98.7596 69.3745 97.0989 69.5362C86.3868 70.6171 84.6045 59.9186 81.7064 58.4162C79.3313 57.179 77.549 59.9549 76.9911 60.985L76.969 61.0286C76.9682 61.0389 76.9636 61.0486 76.9562 61.0558C76.8549 61.2375 76.8052 61.3592 76.8052 61.3592"
        stroke="#2E3860"
        strokeWidth="1.4"
        strokeMiterlimit="10"
      />
      <path
        d="M81.7686 70.8154C81.7686 70.8154 80.6492 74.4307 80.7357 74.972C80.8223 75.5134 82.1277 75.1355 82.1277 75.1355"
        stroke="#2E3860"
        strokeWidth="1.4"
        strokeMiterlimit="10"
      />
      <path
        d="M90.5421 74.6314C92.257 72.9423 92.2256 70.1678 90.472 68.4345C88.7184 66.7012 85.9066 66.6654 84.1916 68.3546C82.4767 70.0437 82.508 72.8182 84.2616 74.5515C86.0153 76.2848 88.8271 76.3206 90.5421 74.6314Z"
        stroke="#2E3860"
        strokeWidth="1.4"
        strokeMiterlimit="10"
      />
      <path
        d="M79.3502 73.2887C81.0651 71.5995 81.0338 68.825 79.2801 67.0917C77.5265 65.3584 74.7147 65.3226 72.9997 67.0118C71.2848 68.701 71.3161 71.4754 73.0698 73.2087C74.8234 74.9421 77.6352 74.9778 79.3502 73.2887Z"
        stroke="#2E3860"
        strokeWidth="1.4"
        strokeMiterlimit="10"
      />
      <path
        d="M76.0757 66.7827C76.5646 66.7805 77.0484 66.8794 77.4962 67.073C77.9439 67.2667 78.3455 67.5508 78.6751 67.907C79.0047 68.2632 79.255 68.6836 79.4098 69.1411C79.5646 69.5986 79.6206 70.0831 79.574 70.5632C79.4964 71.3706 79.1156 72.1202 78.5065 72.6647C77.8973 73.2093 77.1039 73.5094 76.2819 73.5063C75.7931 73.5085 75.3092 73.4095 74.8615 73.2159C74.4138 73.0222 74.0122 72.7381 73.6826 72.3819C73.353 72.0257 73.1027 71.6053 72.9478 71.1478C72.793 70.6903 72.7371 70.2059 72.7837 69.7257C72.8613 68.9183 73.2421 68.1688 73.8512 67.6242C74.4603 67.0797 75.2538 66.7795 76.0757 66.7827ZM76.0757 66.2813C75.1285 66.2789 74.2146 66.6259 73.5133 67.254C72.812 67.8822 72.3738 68.7462 72.2847 69.6767C72.1898 70.7037 72.5035 71.7268 73.1595 72.5297C73.8155 73.3326 74.7622 73.8522 75.7995 73.9786C75.9584 73.9973 76.1183 74.007 76.2783 74.0077C77.2264 74.0114 78.1417 73.665 78.8442 73.0367C79.5467 72.4085 79.9857 71.5437 80.0748 70.6123C80.1697 69.5853 79.856 68.5621 79.2 67.7592C78.544 66.9564 77.5973 66.4367 76.56 66.3103C76.4011 66.2917 76.2413 66.2819 76.0813 66.2813H76.0757Z"
        fill="white"
      />
      <path
        d="M82.9441 70.9593L80.5947 70.6777"
        stroke="#2E3860"
        strokeWidth="1.4"
        strokeMiterlimit="10"
      />
      <path
        d="M90.181 74.2735C91.7017 72.7757 91.6741 70.3158 90.1195 68.7792C88.5649 67.2426 86.0719 67.2111 84.5512 68.7089C83.0306 70.2067 83.0581 72.6666 84.6128 74.2032C86.1674 75.7398 88.6604 75.7713 90.181 74.2735Z"
        fill="white"
        fillOpacity="0.16"
      />
      <path
        d="M78.9911 72.932C80.5124 71.4335 80.4849 68.9725 78.9295 67.4352C77.3742 65.8978 74.88 65.8664 73.3587 67.3649C71.8373 68.8634 71.8649 71.3244 73.4202 72.8617C74.9756 74.399 77.4697 74.4305 78.9911 72.932Z"
        fill="white"
        fillOpacity="0.16"
      />
      <path
        d="M21.5513 163.103C22.8548 162.5 143.07 163.103 143.07 163.103"
        stroke="#2E3860"
        strokeWidth="1.4"
        strokeMiterlimit="10"
      />
      <path
        opacity="0.54"
        d="M15.0241 146.894L2.24253 114.586C2.08418 113.961 2.07228 113.308 2.20773 112.678C2.34319 112.048 2.62244 111.456 3.02427 110.948C3.4261 110.44 3.93995 110.03 4.52679 109.747C5.11362 109.464 5.75801 109.317 6.411 109.317H57.1875C58.3275 109.317 59.4343 109.696 60.3297 110.392C61.2252 111.088 61.8571 112.061 62.1238 113.154L76.1169 145.459C76.2686 146.082 76.2751 146.731 76.1358 147.358C75.9966 147.984 75.7152 148.571 75.3129 149.074C74.9106 149.578 74.3978 149.984 73.8132 150.264C73.2285 150.544 72.5871 150.689 71.9374 150.689H19.9456C18.8138 150.689 17.7145 150.315 16.8227 149.628C15.9308 148.94 15.2977 147.978 15.0241 146.894Z"
        fill="white"
      />
      <path
        d="M15.0241 146.894L2.24253 114.586C2.08418 113.961 2.07228 113.308 2.20773 112.678C2.34319 112.048 2.62244 111.456 3.02427 110.948C3.4261 110.44 3.93995 110.03 4.52679 109.747C5.11362 109.464 5.75801 109.317 6.411 109.317H57.1876C58.3275 109.317 59.4343 109.696 60.3297 110.392C61.2252 111.088 61.8571 112.061 62.1238 113.154L76.1169 145.459C76.2686 146.082 76.2751 146.731 76.1358 147.358C75.9966 147.984 75.7152 148.571 75.3129 149.074C74.9106 149.578 74.3978 149.984 73.8132 150.264C73.2285 150.544 72.5872 150.689 71.9374 150.689H19.9456C18.8138 150.689 17.7145 150.315 16.8227 149.628C15.9308 148.94 15.2977 147.978 15.0241 146.894Z"
        fill="#E2E2FC"
      />
      <path
        d="M15.0241 146.894L2.24253 114.586C2.08418 113.961 2.07228 113.308 2.20773 112.678C2.34319 112.048 2.62244 111.456 3.02427 110.948C3.4261 110.44 3.93995 110.03 4.52679 109.747C5.11362 109.464 5.75801 109.317 6.411 109.317H57.1875C58.3275 109.317 59.4343 109.696 60.3297 110.392C61.2252 111.088 61.8571 112.061 62.1238 113.154L76.1169 145.459C76.2686 146.082 76.2751 146.731 76.1358 147.358C75.9966 147.984 75.7152 148.571 75.3129 149.074C74.9106 149.578 74.3978 149.984 73.8132 150.264C73.2285 150.544 72.5871 150.689 71.9374 150.689H19.9456C18.8138 150.689 17.7145 150.315 16.8227 149.628C15.9308 148.94 15.2977 147.978 15.0241 146.894Z"
        stroke="#2E3860"
        strokeWidth="1.4"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M52.4 116.399C51.7795 115.478 50.765 115.069 50.1316 115.49C49.4982 115.912 49.489 116.989 50.1095 117.91C50.2073 118.05 50.3169 118.182 50.4373 118.304L45.8343 127.891C45.0978 127.408 44.2932 127.288 43.715 127.669C43.5284 127.803 43.3737 127.976 43.2621 128.175C43.1504 128.375 43.0844 128.596 43.0688 128.823L39.924 127.775L37.1751 126.866L36.2766 126.576C36.164 126.243 36.0074 125.926 35.8108 125.633C34.938 124.339 33.513 123.765 32.6237 124.349C31.7344 124.932 31.7252 126.423 32.574 127.708L27.3431 134.762C26.2016 133.837 24.8557 133.552 23.924 134.162C22.6573 134.996 22.6352 137.167 23.8817 139.013C23.9314 139.086 23.9884 139.147 24.04 139.216L20.5473 143.925L20.516 143.971C20.4175 144.102 20.3472 144.251 20.3091 144.409C20.271 144.568 20.2661 144.733 20.2946 144.893C20.3231 145.054 20.3844 145.207 20.4748 145.343C20.5652 145.48 20.6828 145.596 20.8204 145.687C20.9581 145.777 21.1129 145.838 21.2754 145.867C21.4379 145.897 21.6047 145.893 21.7657 145.856C21.9267 145.82 22.0785 145.752 22.2118 145.655C22.3452 145.559 22.4573 145.437 22.5413 145.297L25.6474 140.684C26.6269 141.246 27.6727 141.353 28.4331 140.851C29.6446 140.056 29.7017 138.043 28.6172 136.255L33.6345 128.783C34.371 129.279 35.1921 129.406 35.7776 129.023C36.105 128.795 36.328 128.449 36.3981 128.06L36.7664 128.164L39.5631 128.918L43.1424 129.869C43.2512 130.292 43.4317 130.694 43.6764 131.058C44.5473 132.349 45.9742 132.925 46.8635 132.342C47.7528 131.759 47.7638 130.238 46.8929 128.947C46.7644 128.759 46.6203 128.582 46.4621 128.418L50.8423 118.646C51.3707 119.009 51.947 119.091 52.3724 118.817C53.0149 118.412 53.0241 117.322 52.4 116.399Z"
        fill="white"
      />
      <path
        d="M19.0754 116.928H12.2906C11.9785 116.929 11.6728 116.841 11.4111 116.673C11.1494 116.505 10.9432 116.265 10.8176 115.983C10.7789 115.897 10.7582 115.804 10.7568 115.709C10.7588 115.527 10.8335 115.352 10.9648 115.224C11.0961 115.095 11.2734 115.023 11.4583 115.022H18.674C18.3389 115.587 18.523 116.372 19.0754 116.928Z"
        fill="#F9F9FF"
      />
      <path
        d="M23.4675 116.241C23.4666 116.424 23.3927 116.598 23.262 116.727C23.1313 116.855 22.9543 116.928 22.7697 116.928H19.0744C18.511 116.372 18.338 115.587 18.6786 115.022H21.9375C22.249 115.021 22.5542 115.109 22.8158 115.276C23.0774 115.442 23.2841 115.681 23.4105 115.962C23.4485 116.05 23.4679 116.145 23.4675 116.241Z"
        fill="#F9F9FF"
      />
      <path
        d="M25.1733 120.446C25.1719 120.628 25.0973 120.803 24.9659 120.931C24.8345 121.06 24.6569 121.132 24.4718 121.132H17.3482C17.6925 120.562 17.5213 119.784 16.9561 119.227H23.647C23.9591 119.225 24.2647 119.314 24.5264 119.482C24.7881 119.65 24.9944 119.889 25.1199 120.171C25.1561 120.258 25.1742 120.352 25.1733 120.446Z"
        fill="#F9F9FF"
      />
      <path
        d="M17.3496 121.136H13.9986C13.6871 121.138 13.3819 121.05 13.1202 120.883C12.8586 120.716 12.652 120.478 12.5256 120.197C12.487 120.109 12.4664 120.015 12.4649 119.919C12.4644 119.829 12.482 119.739 12.5168 119.655C12.5516 119.572 12.6028 119.496 12.6675 119.432C12.7322 119.368 12.8091 119.317 12.8938 119.282C12.9784 119.248 13.0692 119.23 13.1608 119.23H16.9574C17.5226 119.783 17.6939 120.56 17.3496 121.136Z"
        fill="#F9F9FF"
      />
      <path
        d="M19.7232 125.316H15.459C15.1475 125.317 14.8424 125.228 14.5809 125.061C14.3194 124.894 14.1127 124.656 13.9861 124.375C13.9474 124.288 13.9267 124.195 13.9253 124.1C13.9258 123.917 13.9998 123.741 14.1313 123.611C14.2627 123.482 14.4409 123.409 14.6268 123.408H19.3182C18.9904 123.97 19.1635 124.749 19.7232 125.316Z"
        fill="#F9F9FF"
      />
      <path
        d="M26.6337 124.623C26.6327 124.805 26.5587 124.979 26.4279 125.107C26.297 125.235 26.1201 125.306 25.9358 125.306H19.7218C19.1694 124.748 18.9853 123.969 19.3241 123.398H25.1073C25.418 123.398 25.722 123.488 25.982 123.655C26.242 123.823 26.4467 124.062 26.5711 124.343C26.611 124.431 26.6323 124.526 26.6337 124.623Z"
        fill="#F9F9FF"
      />
      <path
        d="M47.2953 144.998H43.0292C42.7177 144.999 42.4126 144.911 42.1511 144.744C41.8896 144.577 41.6829 144.338 41.5563 144.057C41.5161 143.971 41.4948 143.878 41.4937 143.783C41.4941 143.6 41.5682 143.424 41.6997 143.294C41.8311 143.164 42.0092 143.091 42.1951 143.091H46.8884C46.5625 143.665 46.7355 144.441 47.2953 144.998Z"
        fill="#2E3860"
      />
      <path
        d="M64.2234 144.315C64.2232 144.405 64.205 144.494 64.1699 144.577C64.1347 144.66 64.0834 144.736 64.0188 144.799C63.9542 144.862 63.8775 144.913 63.7932 144.947C63.7089 144.981 63.6186 144.999 63.5274 144.998H47.2936C46.7412 144.441 46.5571 143.661 46.8959 143.091H62.697C63.0077 143.091 63.3117 143.18 63.5717 143.348C63.8317 143.516 64.0364 143.755 64.1608 144.035C64.2008 144.124 64.2221 144.219 64.2234 144.315Z"
        fill="#2E3860"
      />
      <path
        d="M49.9836 144.999C49.9655 145.035 49.9433 145.07 49.9173 145.102C49.4367 145.76 48.3873 145.816 47.5716 145.233C47.4733 145.161 47.3804 145.083 47.2936 144.999C46.7412 144.441 46.5571 143.661 46.8959 143.091C46.9153 143.055 46.9375 143.02 46.9622 142.987C47.4482 142.335 48.4977 142.277 49.3134 142.86C49.4102 142.931 49.5018 143.008 49.5877 143.091C50.1511 143.649 50.3242 144.432 49.9836 144.999Z"
        fill="white"
      />
      <path
        d="M135.955 142.917L139.79 146.071L140.43 163.102H107.186L101.986 162.472L99.5142 143.548L135.955 142.917Z"
        fill="white"
      />
      <path
        d="M99.5142 143.548L105.268 146.702M99.5142 143.548L135.955 142.917L139.79 146.071M99.5142 143.548L101.986 162.472M105.268 146.702L139.79 146.071M105.268 146.702L107.186 163.102M139.79 146.071L140.43 163.102H107.186M102.071 163.102L101.986 162.472M107.186 163.102L101.986 162.472"
        stroke="#2E3860"
        strokeWidth="1.4"
      />
      <path
        d="M104.568 146.794L100.025 144.431L102.583 162.093L106.674 162.598L104.568 146.794Z"
        fill="#E2E2FC"
      />
      <path
        d="M139.79 147.332L124.446 150.486H140.429"
        stroke="#2E3860"
        strokeWidth="1.4"
      />
      <path
        d="M139.79 153.64L130.839 154.901L139.79 155.532"
        stroke="#2E3860"
        strokeWidth="1.4"
      />
      <path
        d="M100.153 149.225L104.628 151.748H100.153"
        stroke="#2E3860"
        strokeWidth="1.4"
      />
      <path
        d="M106.546 159.317H103.989L107.185 161.21"
        stroke="#2E3860"
        strokeWidth="1.4"
      />
      <path
        d="M106.546 155.533L117.414 157.426L106.546 158.056"
        stroke="#2E3860"
        strokeWidth="1.4"
      />
    </g>
    <defs>
      <clipPath id="clip0_17992_12861">
        <rect width="170" height="164" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default CreateCampaignIcon
